import React from 'react';
import styles from './TextoComMencoes.module.css';

type Props = {
    value?: string | null;
    /**
     * Gera o href da menção a partir do id; por padrão não cria link (usa #).
     * Ex.: (id) => `/admin/usuarios/${id}`
     */
    mentionHref?: (id: string) => string;
    /**
     * Callback opcional ao clicar numa menção. Se retornar false, evita navegação padrão.
     */
    onMentionClick?: (id: string, nome: string) => void | boolean;
    className?: string;
    style?: React.CSSProperties;
};

/**
 * Renderiza texto transformando tokens <@id|nome> em @nome clicáveis/estilizados.
 */
export default function TextoComMencoes({ value, mentionHref, onMentionClick, className, style }: Readonly<Props>) {
    const text = value ?? '';
    const parts: Array<string | { id: string; nome: string }> = [];

    const regex = /<@([^|>]+)\|([^>]+)>/g;
    let lastIdx = 0;
    let match: RegExpExecArray | null;
    while ((match = regex.exec(text)) !== null) {
        const [full, id, nome] = match;
        if (match.index > lastIdx) parts.push(text.slice(lastIdx, match.index));
        parts.push({ id, nome });
        lastIdx = match.index + full.length;
    }
    if (lastIdx < text.length) parts.push(text.slice(lastIdx));

    const handleClick = (e: React.MouseEvent, id: string, nome: string) => {
        const res = onMentionClick?.(id, nome);
        if (res === false) {
            e.preventDefault();
            e.stopPropagation();
        }
    };

    return (
        <div className={[styles.container, className].join(' ')} style={style}>
            {parts.map((p, i) => {
                if (typeof p === 'string') return <React.Fragment key={i}>{p}</React.Fragment>;
                const href = mentionHref ? mentionHref(String(p.id)) : '#';
                return (
                    <a
                        key={i}
                        href={href}
                        className={styles.mention}
                        onClick={(e) => handleClick(e, String(p.id), p.nome)}
                    >
                        @{p.nome}
                    </a>
                );
            })}
        </div>
    );
}
